<script>
import youtubeContainer from '@/components/youtubeContainer';
import vueInstagram from '@/components/vueInstagram';
import vueBandCamp from '@/components/vueBandCamp';

export default {
  name: 'album11',
  components: {
    youtubeContainer,
    vueInstagram,
    vueBandCamp,
  },
  data() {
    return {
      ready: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.ready = true;
    }
  },
};
</script>

<template>
  <div class="uncommon-container" v-if="ready" :class="$mq">

    <div class="contents-container">
      <div class="contents-instagram">
        <vue-instagram :posts="['CHHMQNEHph1']" :show-follow-btn="false"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="title">{{$t('message.shop.bandcamp')}}</div>
      <div class="contents-bandcamp">
        <vue-band-camp
          embedded-url="https://bandcamp.com/EmbeddedPlayer/album=3837551012/size=large/bgcol=333333/linkcol=e32c14/tracklist=false/transparent=true/"
          href-url="https://kyousou-gakudan.bandcamp.com/album/tumitugaru-syuguno-kokugouha-saidohakanaki-rintenno-toga"
          :album-title="$t('message.discography.albums.a11.name')"
          />
      </div>
    </div>

    <div class="contents-container">
      <div class="movie-container">
        <div class="title">{{$t('message.discography.movie')}}</div>
        <youtube-container :file-url="'SvTGS5sUQ2M'"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="movie-container">
        <youtube-container :file-url="'-AwQsoNW0xM'"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="movie-container">
        <youtube-container :file-url="'epNADmggkIE'"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="banners-container">
        <div class="title">{{$t('message.discography.specialThanks')}}</div>
        <a class="banner200x40" target="_blank" :title="'白夜の語り部'"
          href="http://studio-lepus.com/"
        >
          <img src="../assets/img/banner/circle/studio-lepus.gif">
        </a>
        <div class="small">{{$t('message.common.composition')}},{{$t('message.common.jacket')}} 三滝航</div>
      </div>
    </div>
   
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  @import "../css/albumUncommon";
</style>
